import { ProjectCompetitorsModel } from "../models/ProjectCompetitorsModel";
import API, { client } from "./API";

const ProjectCompetitorsService = {
  async getAllProjectCompetitors() {
    const response = await API().get("ProjectCompetitors", {
      method: "GET",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  },
  async getParticularProjectCompetitor(id: number) {
    const response = await API().get("ProjectCompetitors");
    return response.data.filter(
      (cur_pc: ProjectCompetitorsModel) => cur_pc.id === id
    )[0];
  },
  async createProjectCompetitor(data: ProjectCompetitorsModel, id?: number) {
    try {
      const response = await client({
        method: id ? "put" : "post",
        url: id ? `ProjectCompetitors/${id}` : "ProjectCompetitors",
        data: data,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
};

export default ProjectCompetitorsService;
